import Home from './views/Home.vue'
import SearchLicense from './views/SearchLicense.vue'

let routes = [
    {
        path: '/',
        redirect: '/searchLicense',
        hidden: true
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-bar-chart', //图标样式class
        children: [
            { path: '/searchLicense', component: SearchLicense, name: 'SearchLicense'},  //C2D/D2C反查许可           
        ]
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js